import wordmark from '@/assets/images/logo_wordmark.svg';
import { cn } from './cn';

/**
 * The "بلینو" lettering with its pin and car swoosh. It is drawn as a CSS mask over a solid colour
 * (text-navy by default), so it follows the light/dark theme instead of being a fixed-colour image.
 */
export function Wordmark({ className, label = 'بلینو' }: { className?: string; label?: string }) {
  return (
    <span
      role="img"
      aria-label={label}
      className={cn('inline-block aspect-[672/229] h-8 bg-current text-navy', className)}
      style={{ WebkitMask: `url(${wordmark}) center / contain no-repeat`, mask: `url(${wordmark}) center / contain no-repeat` }}
    />
  );
}
